<template>
  <div class="dblb-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title" style="margin-bottom: 0;">
            通知列表
            <div style="text-align: right;position: relative;margin-top: -20px;">
              <el-form :inline="true" size="small" :model="searchForm">
                <el-form-item label="时间">
                  <el-date-picker
                    v-model="searchForm.time"
                    format="yyyy年MM月dd日"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="关键字">
                <el-input v-model="searchForm.search" style="width:200px" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
              </el-form-item>
                <el-form-item>
                  <el-button icon="el-icon-search" type="primary" @click="Search">搜索</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  style="width: 100%"
                  :data="tableData"
                  :show-header="false"
                  :row-style="{cursor: 'pointer'}"
                  @row-click="getDetail">
                  <el-table-column
                    label="标题"
                    width="600">
                    <template slot-scope="scope">
                      <div v-if="scope.row.isRead===0"  style="margin-left: 180px;">
                        <el-badge is-dot style="top:5px;right: 2px;"/>{{scope.row.title}}
                      </div>
                      <div v-if="scope.row.isRead===1" style="margin-left: 180px;">{{scope.row.title}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="时间"
                    align="center"
                    prop="time">
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="通知详情"
      :visible.sync="detailDialog"
      width="40%">
      <div v-loading="detailLoading">
        <div>{{ detail.title }}</div>
        <div style="margin-top: 15px;">{{ detail.time }}</div>
        <el-divider/>
        <el-card class="box-card">
          <div>{{ detail.content }}</div>
          <div style="margin-top:15px;font-size:14px;color:#99a9bf;">注：这里是订单的基本信息，点击订单号可查看订单详情</div>
          <div style="margin-top:15px;font-size:13px;">客户名称：{{ detail.allName }}</div>
          <div style="margin-top:8px;font-size:13px;">订单号：
            <el-button type="text" style="font-size:13px;" @click="goOrder(detail.orderId)">{{ detail.orderNum }}</el-button>
          </div>
          <div style="margin-top:10px;font-size:13px;">客户地址：{{ detail.address }}</div>
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="detailDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getUserNotice, getOrderNoticeDetail } from '@/api/user'

export default {
  name: 'Notice',
  data() {
    return {
      total: 0,
      pageSize: 20,
      currentPage: 1,
      loading: false,
      tableData: [],
      searchForm: {
        search: '',
        time: null
      },
      detail: {},
      detailLoading: false,
      detailDialog: false
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getUserNotice()
  },
  methods: {
    getUserNotice() {
      const menu = JSON.parse(sessionStorage.getItem('ElichainUserRoleMenu'))
      let jd = 0
      let bj = 0
      for (const m of menu) {
        if (m.name === '生产管理') {
          for (const i of m.menu) {
            if (i.num === 'jd') {
              jd = 1
            }
            if (i.num === 'dbj') {
              bj = 1
            }
          }
        }
      }
      this.loading = true
      let startTime = ''
      let endTime = ''
      if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
        startTime = this.searchForm.time[0]
        endTime = this.searchForm.time[1]
      }
      const data = {
        userid: this.user.dUserid,
        limit: this.pageSize,
        page: this.currentPage,
        keyword: this.searchForm.search,
        startTime: startTime,
        endTime: endTime,
        bj: bj,
        jd: jd
      }
      getUserNotice(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.loading = false
      })
    },
    Search() {
      this.currentPage = 1
      this.getUserNotice()
    },
    getDetail(row, column, event) {
      this.detailDialog = true
      this.detailLoading = true
      getOrderNoticeDetail({ id: row.id, userid: this.user.dUserid }).then(response => {
        this.detail = response.data
        this.detailLoading = false
      }).catch(() => {
        this.detailLoading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getUserNotice()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getUserNotice()
    },
    goOrder(orderId) {
      this.detailDialog = false
      this.$router.push({ path: '/work/order/' + orderId })
    }
  }
}
</script>

<style lang="scss" scoped>
.dblb-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
    .el-divider--horizontal{
      margin: 15px 0;
    }
  }
}
</style>
